import React from 'react'
import { Modal } from 'react-bootstrap'
import { X } from '@phosphor-icons/react'

interface Props {
  show: boolean
  onClose: () => void
  onConfirm: () => void
}

const DeleteTimeOffModal = ({ show, onClose, onConfirm }: Props) => (
  <Modal
    show={show}
    onHide={onClose}
    centered
    dialogClassName="log-modal-dialog log-modal-dialog--compact"
    contentClassName="log-modal-content"
  >
    <div className="log-modal log-modal--compact">
      <div className="log-modal__header">
        <h2 className="log-modal__title">Delete Time Off</h2>
        <button
          className="log-modal__close"
          onClick={onClose}
          aria-label="Close"
        >
          <X size={20} weight="regular" />
        </button>
      </div>

      <div className="log-modal__body">
        <p className="log-modal__delete-message">
          Are you sure you want to delete this time off? The process cannot be
          undone.
        </p>
      </div>

      <div className="log-modal__footer log-modal__footer--padded">
        <button
          className="log-modal__btn log-modal__btn--cancel"
          onClick={onClose}
        >
          Cancel
        </button>
        <button
          className="log-modal__btn log-modal__btn--delete"
          onClick={onConfirm}
        >
          Delete
        </button>
      </div>
    </div>
  </Modal>
)

export default DeleteTimeOffModal
